"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useOnMouseMove_1 = require("../hooks/useOnMouseMove");
const Move = ({ onMouseMove, calculateHoveredFeatures, }) => {
    useOnMouseMove_1.useOnMouseMove(onMouseMove, calculateHoveredFeatures);
    return null;
};
exports.default = Move;
//# sourceMappingURL=Move.js.map